export default async ({ store }) => {
  if (!process.client) return;

  if (!store.state.splash_called) {
    await store.dispatch("callSplash");
  }
};
